import { io, Socket } from "socket.io-client";
import getConfig from "@/configuration";

let socket: Socket | null = null;

export function connectSocket(token: string): Socket {
  if (
    socket?.connected &&
    socket.auth &&
    (socket.auth as { token?: string }).token === token
  ) {
    return socket;
  }

  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  const { apiUrl } = getConfig();

  socket = io(apiUrl, {
    auth: { token },
    transports: ["websocket"],
  });

  socket.on("connect", () => {
    console.log("[Socket] Conectado al WebSocket");
  });

  socket.on("disconnect", (reason) => {
    console.log("[Socket] Desconectado:", reason);
  });

  socket.on("connect_error", (error) => {
    console.error("[Socket] Error de conexión:", error.message);
  });

  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

window.addEventListener("beforeunload", () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
});

export function getSocket(): Socket | null {
  return socket;
}
